var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray2"},[_c('top-banner',{attrs:{"css":_vm.banner.css,"data":_vm.banner.data}}),_c('main-product'),_c('contact-form',{staticClass:"pb-20"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }